import { TYPES } from "@actions/userlists-actions";

import INITIAL_STATE from "./initial-state";

const userlistsReducer = (state = INITIAL_STATE.userlists, action) => {
  switch (action.type) {
    case TYPES.SET_USERLISTS: {
      return {
        ...state,
        userLists: action.userLists,
      };
    }

    case TYPES.OPEN_ADDED_TO_WISHLIST_TOAST: {
      return {
        ...state,
        ongoingAction: "addedToWishlist",
        product: action.product,
      };
    }

    case TYPES.CLOSE_ADDED_TO_WISHLIST_TOAST: {
      return {
        ...state,
        ongoingAction: "",
        product: {},
      };
    }

    case TYPES.OPEN_ADD_TO_USERLIST_OFFCANVAS: {
      return {
        ...state,
        ongoingAction: "addToUserList",
        product: action.product,
      };
    }

    case TYPES.CLOSE_ADD_TO_USERLIST_OFFCANVAS: {
      return {
        ...state,
        ongoingAction: "",
        product: {},
      };
    }

    case TYPES.OPEN_ADDED_TO_USERLIST_TOAST: {
      return {
        ...state,
        ongoingAction: "addedToUserList",
        userList: action.userList,
      };
    }

    case TYPES.CLOSE_ADDED_TO_USERLIST_TOAST: {
      return {
        ...state,
        ongoingAction: "",
        userList: {},
      };
    }

    case TYPES.CLOSE_USERLIST_MANAGER_ELEMENTS: {
      return {
        ...state,
        ongoingAction: "",
        product: {},
        userList: {},
      };
    }

    case TYPES.OPEN_AUTH_OFFCANVAS_PRIOR_TO_LIKE_PRODUCT: {
      return {
        ...state,
        ongoingAction: "authUserPriorToLikeProduct",
        product: action.product,
      };
    }

    case TYPES.CLOSE_AUTH_OFFCANVAS_PRIOR_TO_LIKE_PRODUCT: {
      return {
        ...state,
        ongoingAction: "",
        product: {},
      };
    }

    default:
      return state;
  }
};

export default userlistsReducer;
